import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import './index.scss';
import api from '../api';

const PrivateRoute = ({ element: Element, acessosPermitidos }) => {
    const [user, setUser] = useState(null);
    const [emailNaoVerificado, setEmailNaoVerificado] = useState(false);
    const [emailPendenteVerificacao, setEmailPendenteVerificacao] = useState('');
    const [loading, setLoading] = useState(true);
    const [siteStatus, setSiteStatus] = useState('online');

    const acessosKey = Array.isArray(acessosPermitidos) ? acessosPermitidos.join('|') : '';

    useEffect(() => {
        const verificarToken = async () => {
            try {
                const [statusRes, tokenRes] = await Promise.allSettled([
                    api.get('/api/site-status'),
                    api.get('/api/verificar-token', { withCredentials: true })
                ]);

                if (statusRes.status === 'fulfilled') {
                    setSiteStatus(statusRes.value.data?.status || 'online');
                }

                if (tokenRes.status === 'fulfilled') {
                    const response = tokenRes.value;

                    if (response.data.success) {
                        const usuario = response.data.user;

                        if (!usuario.email_verificado) {
                            setEmailNaoVerificado(true);
                            setEmailPendenteVerificacao(usuario.email || '');
                            return;
                        }

                        if (acessosPermitidos.includes(usuario.nivel_acesso)) {
                            setUser(usuario);
                        }
                    }
                }
            } catch (error) {
                console.error('Token inválido ou não encontrado:', error.response?.data || error.message);
            } finally {
                setLoading(false);
            }
        };
        verificarToken();
    }, [acessosKey]);

    if (loading) {
        return null;
    }

    if (siteStatus === 'manutencao' && user?.nivel_acesso !== 'Administrador') {
        return <Navigate to="/manutencao" />;
    }

    if (emailNaoVerificado) {
        return <Navigate to="/confirmacao-email" state={{ email: emailPendenteVerificacao }} replace />;
    }

    if (!user) return <Navigate to="/login" />;

    return <Element />;
};

export default PrivateRoute;
